/* Shared formatters + tiny primitives for the RIPP MEME radar. Accent: acid green --meme. */
export const usd = (n, d = 0) => (n == null || !Number.isFinite(Number(n)) ? "—" : `$${Number(n).toLocaleString(undefined, { maximumFractionDigits: d, minimumFractionDigits: d })}`);
export const compact = (n) => (n == null ? "—" : Number(n) >= 1e6 ? `$${(n / 1e6).toFixed(2)}M` : Number(n) >= 1e3 ? `$${(n / 1e3).toFixed(1)}K` : `$${Number(n).toFixed(0)}`);
export const pct = (n, d = 1) => (n == null || !Number.isFinite(Number(n)) ? "—" : `${Number(n) >= 0 ? "+" : ""}${Number(n).toFixed(d)}%`);
export const age = (m) => (m == null ? "—" : m < 60 ? `${Math.round(m)}m` : m < 1440 ? `${(m / 60).toFixed(1)}h` : `${(m / 1440).toFixed(1)}d`);
export const px = (p) => (p == null ? "—" : Number(p) >= 1 ? Number(p).toFixed(4) : Number(p).toPrecision(4));
export const ago = (t) => (t == null ? "—" : `${Math.max(0, Math.round(Date.now() / 1000 - t))}s ago`);

export const VERDICT_TONE = { PASS: "emerald", WARN: "amber", REJECT: "red" };
export const STANCE_TONE = { BUY: "emerald", WATCH: "amber", AVOID: "red" };
export const DECISION_TONE = { ENTER: "emerald", WATCH: "amber", PASS: "text2" };

export const Tone = ({ tone = "text1", children, className = "", testid }) => (
  <span data-testid={testid} className={className} style={{ color: `var(--r2-${tone})` }}>{children}</span>
);

export const Signed = ({ v, fmt = (n) => n.toFixed(2), testid, className = "" }) => (
  <span data-testid={testid} className={`tabular-nums ${className}`} style={{ color: v == null ? "var(--r2-text2)" : v >= 0 ? "var(--r2-emerald)" : "var(--r2-red)" }}>
    {v == null ? "—" : `${v >= 0 ? "+" : ""}${fmt(v)}`}
  </span>
);

export const TokenIcon = ({ s, size = 22 }) => (
  s?.icon ? <img src={s.icon} alt="" width={size} height={size} className="rounded-full object-cover shrink-0 bg-black/40" onError={(e) => { e.currentTarget.style.visibility = "hidden"; }} />
    : <span className="grid place-items-center rounded-full bg-[var(--r2-surface)] border border-[var(--r2-border)] text-[8px] font-mono shrink-0" style={{ width: size, height: size }}>{(s?.symbol || "?").slice(0, 2)}</span>
);
